<div class="no-data-container" [ngClass]="class">
    <img [src]="svgSrc" (error)="onIconError($event)">
</div>
